import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrganizationPartState, adapter } from './organization-part.reducer';

export const selectOrganizationPartState = createFeatureSelector<OrganizationPartState>('organizationParts');

export const {
    selectIds: selectOrganizationPartIds,
    selectEntities: selectOrganizationPartEntities,
    selectAll: selectAllOrganizationParts,
    selectTotal: selectTotalOrganizationParts
} = adapter.getSelectors(selectOrganizationPartState);

export const getSelectedOrganizationPartId = createSelector(
    selectOrganizationPartState,
    (state) => state.selectedOrganizationPartId
);

export const getSelectedOrganizationPart = createSelector(
    selectOrganizationPartEntities,
    getSelectedOrganizationPartId,
    (entities, selectedId) => (selectedId ? entities[selectedId] : null)
);

export const organizationPartsLoading = createSelector(selectOrganizationPartState, (state) => state.loading);

export const organizationPartsError = createSelector(selectOrganizationPartState, (state) => state.error);

export const getOrganizationPartById = (id: number) =>
    createSelector(selectOrganizationPartEntities, (entities) => entities[id] || null);

export const getOrganizationPartsByIds = (ids: number[]) =>
    createSelector(selectAllOrganizationParts, (organizationParts) =>
        organizationParts.filter((part) => ids.includes(part.id))
    );
